import LazyImage from "@insite/mobius/LazyImage";
import ChevronDown from "@sonic/CustomComponents/headless/elements/icon/icons/chevron-down";
import ChevronLeft from "@sonic/CustomComponents/headless/elements/icon/icons/chevron-left";
import ChevronRight from "@sonic/CustomComponents/headless/elements/icon/icons/chevron-right";
import Close from "@sonic/CustomComponents/headless/elements/icon/icons/close";
import ArrowLeft from "@sonic/CustomComponents/headless/elements/icon/icons/glyphs-arrow-bold-left";
import ArrowRight from "@sonic/CustomComponents/headless/elements/icon/icons/glyphs-arrow-bold-right";
import ChevronDropDown from "@sonic/CustomComponents/headless/elements/icon/icons/glyphs-chevrons-slim-down";
import Cart from "@sonic/CustomComponents/headless/elements/icon/icons/icons-cart-filled";
import CloseFilled from "@sonic/CustomComponents/headless/elements/icon/icons/icons-close-filled";
import iconsDehashed from "@sonic/CustomComponents/headless/elements/icon/icons/icons-dehashed";
import Favorites from "@sonic/CustomComponents/headless/elements/icon/icons/icons-favorite-filled";
import iconsHashed from "@sonic/CustomComponents/headless/elements/icon/icons/icons-hashed";
import Home from "@sonic/CustomComponents/headless/elements/icon/icons/icons-home-filled";
import InformationFilled from "@sonic/CustomComponents/headless/elements/icon/icons/icons-information-filled";
import User from "@sonic/CustomComponents/headless/elements/icon/icons/icons-login-filled";
import Menu from "@sonic/CustomComponents/headless/elements/icon/icons/icons-menu";
import Search from "@sonic/CustomComponents/headless/elements/icon/icons/icons-search";
import React from "react";

const iconMap = {
    arrowLeft: ArrowLeft,
    arrowRight: ArrowRight,
    cart: Cart,
    chevronDown: ChevronDown,
    chevronDropDown: ChevronDropDown,
    chevronLeft: ChevronLeft,
    chevronRight: ChevronRight,
    closeFilled: CloseFilled,
    close: Close,
    favorites: Favorites,
    home: Home,
    info: InformationFilled,
    dehashed: iconsDehashed,
    hashed: iconsHashed,
    menu: Menu,
    search: Search,
    user: User,
};

export type Icons =
    | "cart"
    | "user"
    | "favorites"
    | "search"
    | "chevronDown"
    | "chevronDropDown"
    | "chevronLeft"
    | "chevronRight"
    | "arrowLeft"
    | "arrowRight"
    | "home"
    | "info"
    | "dehashed"
    | "hashed"
    | "menu"
    | "close"
    | "closeFilled";

export interface IconProps {
    height?: number;
    width?: number;
    color?: string;
    className?: string;
}

interface OwnProps extends IconProps {
    icon: Icons;
}

export const Icon: React.FC<OwnProps> = ({ icon, height, width, color, className }) => {
    const Element = iconMap[icon];
    if (!Element) {
        return null;
    }
    return <Element color={color} className={`${className} icon`} width={width || 24} height={height || 24} />;
};

interface FlagProps extends IconProps {
    flag: string;
}

export const FlagIcon: React.FC<FlagProps> = ({ flag, height, width, className }) => {
    const imgSrc = `/staticContent/img/flags/${flag}.svg`;
    const imgWidth = `${width || 24}`;
    const imgHeight = `${height || 24}`;

    return <LazyImage src={imgSrc} altText="" width={imgWidth} height={imgHeight} className={className} />;
};
